import styled, { css } from 'styled-components'
import { BREAKPOINTS } from '@at/window-utils/lib/responsive-utils/match-media.util'

export const StyledSearchUl = styled.ul`
    display: contents;
    list-style-type: none;
`

export enum GRID_SPANS {
    NARROW = 1,
    MEDIUM = 4,
    EXWIDE = 3,
}

export const StyledSearchLI = styled.li<{
    $hasProminenceLabel?: string | boolean | null
}>`
    padding: 0;
    marker: none;
    position: relative;

    ${({ $hasProminenceLabel }) =>
        css`
            margin-bottom: 16px;
            ${$hasProminenceLabel ? 'margin-top: 16px;' : null}
            grid-column: span ${GRID_SPANS.NARROW};
            @media (min-width: ${BREAKPOINTS.MEDIUM}px) {
                ${$hasProminenceLabel ? 'margin-top: 0;' : null}

                grid-column: span ${GRID_SPANS.MEDIUM};
                margin: 16px 0;
            }
            @media (min-width: ${BREAKPOINTS.WIDE}px) {
                grid-column: span ${GRID_SPANS.MEDIUM};
            }
            @media (min-width: 1366px) {
                grid-column: span ${GRID_SPANS.EXWIDE};
            }
        `}

    border-radius: 16px;

    // Don't display empty GPT position
    :has([style*='display: none']),
    :has(iframe:not([data-load-complete='true'])),
    :has([id*='gpt-ad-desktop-search']:empty),
    :has([id*='gpt-ad-mobile-search']:empty) {
        display: none;
    }
`

export const StyledGPTWrapper = styled.div`
    text-decoration: none;
    color: inherit;
    position: relative;
    background: #ffffff;
    border-radius: 16px;
    overflow: hidden;
    height: 100%;
    box-shadow: 0px 1px 5px 0px #0000001a;
`
